var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cancel-heading',{attrs:{"is-centered":""}},[_vm._v("Schedule Today")]),_vm._v(" "),_c('cancel-content',{attrs:{"is-centered":""}},[_vm._v("\n    Schedule your Free 30-minute 1-on-1 coaching call by\n    "),_c('a',{attrs:{"href":"https://calendly.com/forefrontcrm/onboarding","target":"_blank"}},[_vm._v("clicking here")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }